$(document).ready(function() {
  if (!document.querySelector("#identity_proof")) { return null };

  const firstDocumentZone = document.querySelector("#identity_proof");

  const linkDocumentField = (documentZone) => {
    const documentName = documentZone.id;
    const documentSelected = documentZone.querySelector(`[data-selected-document="${documentName}_selected"]`);
    const documentToggleZone = documentZone.querySelector(`#toggle_zone_${documentName}s`);
    const documentToggles = documentZone.querySelectorAll(`.dropzone_toggle_${documentName}`);
    const documentSingleUpload = documentZone.querySelector(`#${documentName}_single_document`);
    const documentFrontAndBack = document.querySelector(`#${documentName}_documents`);

    const handleDocumentSelection = (documentSelected) => {
      const selectedOption = documentSelected.selectedIndex;
      const doubleSidedIndexOptions = ["1", "4", "5"].map(option => parseInt(option));

      if (doubleSidedIndexOptions.includes(selectedOption)) {
        documentToggleZone.classList.remove("d-none");
      } else {
        documentToggleZone.classList.add("d-none");
      }

      handleDocumentToggle(documentToggleZone);
    };

    const handleDocumentToggle = (toggle) => {
      if (toggle.value === "2" && toggle.checked) {
        documentSingleUpload.classList.add("d-none");
        documentFrontAndBack.classList.remove("d-none");
      } else {
        documentSingleUpload.classList.remove("d-none");
        documentFrontAndBack.classList.add("d-none");
      }
    };

    $(documentSelected).on("change", (event) => {
      handleDocumentSelection(event.target);
    });

    handleDocumentSelection(documentSelected);

    documentToggles.forEach(toggle => {
      toggle.addEventListener("change", (event) => {
        handleDocumentToggle(event.currentTarget);
      });

      handleDocumentToggle(toggle);
    });
  };

  linkDocumentField(firstDocumentZone);
});
